import React, { useState } from 'react'

export default function Result ({ result }) {

  const [showMore, setShowMore] = useState(false)

  const handleShowMore = (e) => {
    e.preventDefault()
    setShowMore(true)
  }

  const renderTags = () => {
    const remaining = result.categories.length - 2
    const triggered = remaining > 0 && !showMore
    const cls = triggered ? ' tags--show-more' : ''

    return (
      <div className={'course-card__tags tags' + cls}>
        {result.categories && Array.isArray(result.categories) && result.categories.map((category, index) => {
          const catCls = category.color ? ' tag--' + category.color : ''
          return <div className={'tag' + catCls} key={index}>{category.name}</div>
        })}
        {triggered ? (
          <div className="tag tag--show-more" onClick={handleShowMore}>{remaining}+</div>
        ) : null}
      </div>
    )
  }

  return (
    <a href={result.permalink} className="course-card course-card--search-card">
      <div className="course-card__title-container">
        {renderTags()}
        <h3 className="course-card__title">{result.title}</h3>
      </div>
      <div className="course-card__infos">
        <div className="course-card__info course-card__info--date">
          <span className="course-card__info-tagline tagline tagline--small tagline--prim tagline--bold">Startdato</span>
          {result.start_date ? (
            <span className="course-card__info-text" title={result.start_date}>{result.start_date}</span>
          ) : (
            <span className="course-card__info-text" title="Flexibelt">{result.text}</span>
          )}
        </div>
        <span className="course-card__info-separator"><></></span>
        <div className="course-card__info course-card__info--price">
          <span className="course-card__info-tagline tagline tagline--small tagline--prim tagline--bold">Pris fra</span>
          {result.price ? (
            <span className="course-card__info-text" title={result.price}>{result.price}</span>
          ) : (
            <span className="course-card__info-text" title="-">-</span>
          )}
        </div>
        <span className="course-card__info-separator"><></></span>
        <div className="course-card__info course-card__info--type">
          <span className="course-card__info-tagline tagline tagline--small tagline--prim tagline--bold">Varighed</span>
          {result.duration ? (
            <span className="course-card__info-text" title={result.duration}>{result.duration}</span>
          ) : (
            <span className="course-card__info-text" title="-">-</span>
          )}
        </div>
      </div>
      <div className="course-card__button button-section">
        <div className="button button--full-width">Læs mere og tilmeld</div>
      </div>
    </a>
  )
}